import React from 'react';
import { useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { Container, Content } from './styles';

// import { Container } from './styles';

const Main: React.FC = ({children}) => {
  const menuOpen = useSelector((state: IApplicationState) => state.system.menuOpen);

  return <Container menuOpen={menuOpen}>
      <Content>
        {children}
      </Content>
  </Container>;
}

export default Main;